jQuery( function( $ ) {


	/**
	 * Functions
	 */

	// Scroll_show
	var scroll_show;

	function scroll_showInit() {
		scroll_show = $( '.scroll_show' );

		var scroll_showSet = function() {
			scroll_show.each( function() {
				$( this ).data( 'showTop', $( this ).offset().top - ( $( window ).height() / 1.3 ) );
			} );
			scroll_showScroll();
		};

		var scroll_showScroll = function() {
			if ( ! scroll_show.get( 0 ) ) return false;
			var scrollTop = $( window ).scrollTop();
			scroll_show.each( function() {
				var element = $( this );
				if ( scrollTop > element.data( 'showTop' ) ) {
					var delay = element.data( 'show_delay' ) || 0;
					setTimeout( function() {
						element.addClass( 'show' );
					}, delay );
				} else {
					element.removeClass( 'show' );
				}
			} );
		};

		$( window ).resize( function() {
			scroll_showSet();
		} );
		$( window ).scroll( function() {
			scroll_showScroll();
		} );

		scroll_showSet();
	}

	scroll_showInit();

} );
